<template>
  <div>
		<div class="page-wrapper introducer l-pb-80">
			<div class="introducer__content">
				<h1 class="introducer__title" v-html="$t('introducerText1')"></h1>
				<p class="introducer__text">{{ $t('introducerText2') }}</p>
				<a class="play" href="#" @click="toggleYoutubeVideoPopup($t('videoYoutubeId'), 1120, 630)">
					<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 142.448 142.448" style="enable-background:new 0 0 142.448 142.448;" xml:space="preserve"> <g> <path style="fill:#1D1D1B;" d="M142.411,68.9C141.216,31.48,110.968,1.233,73.549,0.038c-20.361-0.646-39.41,7.104-53.488,21.639 C6.527,35.65-0.584,54.071,0.038,73.549c1.194,37.419,31.442,67.667,68.861,68.861c0.779,0.025,1.551,0.037,2.325,0.037 c19.454,0,37.624-7.698,51.163-21.676C135.921,106.799,143.033,88.377,142.411,68.9z M111.613,110.336 c-10.688,11.035-25.032,17.112-40.389,17.112c-0.614,0-1.228-0.01-1.847-0.029c-29.532-0.943-53.404-24.815-54.348-54.348 c-0.491-15.382,5.122-29.928,15.806-40.958c10.688-11.035,25.032-17.112,40.389-17.112c0.614,0,1.228,0.01,1.847,0.029 c29.532,0.943,53.404,24.815,54.348,54.348C127.91,84.76,122.296,99.306,111.613,110.336z"/> <path style="fill:#1D1D1B;" d="M94.585,67.086L63.001,44.44c-3.369-2.416-8.059-0.008-8.059,4.138v45.293 c0,4.146,4.69,6.554,8.059,4.138l31.583-22.647C97.418,73.331,97.418,69.118,94.585,67.086z"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>
					{{ $t('general.watchVideo') }}
				</a>
				<p class="introducer__conditions">{{ $t('availabilityCondition') }}</p>
			</div>
			<div><img :src="require('@/' + $t('introducerImage'))" alt="" class="introducer__image" /></div>
		</div>
		<div class="page-wrapper introducer introducer--reversed l-pb-80">
			<div class="introducer__content">
				<h1 class="introducer__title">{{ $t('organized.title') }}</h1>
				<p class="introducer__text" v-html="$t('organized.text1')"></p>
				<p class="introducer__text" v-html="$t('organized.text2')"></p>
			</div>
			<div><img :src="require('@/' + $t('organized.image'))" alt="" class="introducer__image introducer__image--small" /></div>
		</div>
		<div class="page-wrapper introducer l-pb-80">
			<div class="introducer__content">
				<h1 class="introducer__title">{{ $t('ontrack.title') }}</h1>
				<p class="introducer__text" v-html="$t('ontrack.text1')"></p>
			</div>
			<div><img :src="require('@/' + $t('ontrack.image'))"  alt="" class="introducer__image introducer__image--small" /></div>
		</div>	
		<showcaser class="page-wrapper l-pb-80" :items="$t('keyFeatures.items')">
			<h1 class="showcaser-title">{{ $t('keyFeatures.title') }}</h1>
			<p class="showcase-text" v-html="$t('keyFeatures.subtitle')"></p>
		</showcaser>
		<div class="page-wrapper introducer introducer--reversed l-pb-80">
			<div class="introducer__content">
				<h1 class="introducer__title">{{ $t('teams.title') }}</h1>
				<p class="introducer__text" v-html="$t('teams.text1')"></p>
			</div>
			<div><img :src="require('@/' + $t('teams.image'))" alt="" class="introducer__image introducer__image--small" /></div>
		</div>
		<div class="jumbotron jumbotron--image jumbotron--large" :style="'background-image: url(' + require('@/' + $t('jumbotronImage')) + ')'">
			<section class="section-wrapper section-wrapper--large">
				<h1 class="title title--white title--bold">{{ $t('jumbotronTitle') }}</h1>
				<h2 class="subtitle title--white">{{ $t('jumbotronSubtitle') }}</h2>
				<a href="https://prospectsinc.zendesk.com/" target="_blank" class="button button--large button--redFade">{{ $t('general.learnMore') }}</a>
			</section>
		</div>
  </div>
</template>


<script>
import videoMixin from '@/video-mixin.js'
import Showcaser from '@/components/utils/Showcaser.vue'

export default {
	components: { Showcaser },
  	mixins: [videoMixin],
	mounted () {

	},

	data () {
		return {

		}
	},
	i18n: {
		messages: {
			'en-US': {
				introducerText2: "Prospects CRM is the ONLY CRM that seamlessly integrates with your MLS listing and client data (in real-time!), creating all kinds of timesaving automations and premium engagement tools.",
			},
			'en-CA': {
				introducerImage: "assets/pages/crm/introducer-en-ca.jpg",
				introducerText1: "A Different<br/>Kind of CRM",
				introducerText2: "Prospects CRM is the ONLY CRM that seamlessly integrates with your listings and client data (in real-time!), creating all kinds of timesaving automations and premium engagement tools.",
				availabilityCondition: "*Available as a member benefit or by agent-direct subscription in participating markets.",
				videoYoutubeId: "2iY9n5SiyZQ",
				organized: {
					title: "It Keeps You Organized",
					text1: "<span class='u-weight-bold'>Seemless integrations with Matrix™, OneHome™ and @:mobileName® keep your contacts and client activities perfectly synched and organized in your CRM Database.</span>",
					text2: "Sales stages and keywords let you segment and target your contacts with the right information at the right time.",
					image: "assets/pages/crm/organized-en-ca.jpg"
				},
				ontrack: {
					title: "It Keeps You on Track",
					text1: "<span class='u-weight-bold'>Your CRM dashboard and Virtual Assistant make it easy for you to stay focused</span> on what matters most and take instant action on your highest priority opportunities.",
					image: "assets/pages/crm/ontrack-en-ca.jpg"
				},
				teams: {
					title: "Perfect for Teams Too!",
					text1: "<span class='u-weight-bold'>Working together effectively is critical to team success. With Prospects CRM you can easily share information and apply best practices across your team. </span> View schedules, assign activities, and share contacts, action plans and notes. The Team Administrator has full control over user roles and permissions.",
					image: "assets/pages/crm/teams-en-ca.jpg"
				},
				keyFeatures: {
					title: "It Keeps You Connected",
					subtitle: "<span class='u-weight-bold'>Prospects CRM offers premium content and engagement tools powered by listing data & market insights.</span> These features are so easy to use, you'll be turning your database into a data bank in no time!",
					items: [
						{ title: 'Email templates & valuable content', imagePath: 'assets/pages/crm/showcase-content-en-ca.jpg' }, 
						{ title: 'Action plans for every sales stage', imagePath: 'assets/pages/crm/showcase-actionplans-en-ca.jpg' }, 
						{ title: 'Insightful market reports', imagePath: 'assets/pages/crm/showcase-marketreport-en-ca.jpg' }, 
						{ title: 'Automatic Facebook publishing', imagePath: 'assets/pages/crm/showcase-facebook-en-ca.jpg' }, 
						{ title: 'Virtual cards for every occasion', imagePath: 'assets/pages/crm/showcase-cards-en-ca.jpg' }, 
						{ title: 'Activity reports', imagePath: 'assets/pages/crm/showcase-activityreport-en-ca.jpg' }
					]
				},
				jumbotronImage: "assets/jumbotron-red.jpg",
				jumbotronTitle: "Learning Resources",
				jumbotronSubtitle: "Maximize the power of @:(crmName). We have videos, webinars, and guides to help you.",
			},
			'fr-CA': {
				introducerImage: "assets/pages/crm/introducer-fr-ca.jpg",
				introducerText1: "Un CRM unique<br/>dans l'industrie",
				introducerText2: "Prospects CRM est le seul outil de productivité et d'engagement client entièrement intégré avec Centris.",
				availabilityCondition: "*Offert exclusivement aux membres de Centris.",
				videoYoutubeId: "oen0aOej3lc",
				organized: {
					title: "Organisez vos affaires",
					text1: "<span class='u-weight-bold'>L'intégration avec Matrix™, le portail client et Prospects Mobile garde vos contacts et activités parfaitement synchronisées et organisées dans votre base de données CRM.</span>",
					text2: "Les étapes de vente et les mots-clés permettent de catégoriser et de cibler vos contacts avec la bonne information au moment le plus opportun.",
					image: "assets/pages/crm/organized-fr-ca.jpg"
				},
				ontrack: {
					title: "Gardez le contrôle",
					text1: "<span class='u-weight-bold'>L'assistant virtuel et le tableau de bord vous aideront à prioriser vos activités</span> et à maintenir un suivi ponctuel et efficace sur vos occasions d'affaires les plus importantes.",
					image: "assets/pages/crm/ontrack-fr-ca.jpg"
				},
				teams: {
					title: "Idéal pour les équipes!",
					text1: "<span class='u-weight-bold'>Travailler ensemble efficacement est essentiel au succès d'une équipe. Prospects CRM facilite le partage d'informations et la mise en place de meilleures pratiques de travail entre coéquipiers. </span> Consultez vos horaires, assignez des activités et partagez vos contacts, vos plans d'action et vos notes. L'administrateur de l'équipe est en plein contrôle des rôles et des permissions d'équipe.",
					image: "assets/pages/crm/teams-fr-ca.jpg"
				},
				keyFeatures: {
					title: "Restez connecté",
					subtitle: "<span class='u-weight-bold'>Prospects CRM offre un vaste choix de contenu professionnel et d'outils d'engagement client propulsés par les données Centris et du marché immobilier.</span> Avec autant de fonctions faciles d'utilisation, Prospects CRM vous permettra de réaliser rapidement le plein potentiel de vos ambitions!",
					items: [
						{ title: 'Modèles de texte', imagePath: 'assets/pages/crm/showcase-content-fr-ca.jpg' }, 
						{ title: "Plans d'action pour toutes les étapes de vente", imagePath: 'assets/pages/crm/showcase-actionplans-fr-ca.jpg' }, 
						{ title: 'Rapports de marché informatifs', imagePath: 'assets/pages/crm/showcase-marketreport-fr-ca.jpg' }, 
						{ title: 'Publication automatisée sur Facebook', imagePath: 'assets/pages/crm/showcase-facebook-fr-ca.jpg' }, 
						{ title: 'Cartes virtuelles pour toutes les occasions', imagePath: 'assets/pages/crm/showcase-cards-fr-ca.jpg' }, 
						{ title: "Rapports d'activité", imagePath: 'assets/pages/crm/showcase-activityreport-fr-ca.jpg' }
					]
				},
				jumbotronImage: "assets/jumbotron-red.jpg",
				jumbotronTitle: "Ressources d'apprentissage",
				jumbotronSubtitle: "Maximisez la puissance de Prospects CRM. Nous avons des vidéos, des webinaires et des guides pour vous aider.",
			}
		}
	},	
	computed: {

	},
	methods: {

	}
};
</script>

<style scoped>
	.introducer { display: flex; align-items: center; }
	.introducer--reversed { flex-direction: row-reverse; }
	.introducer > * { flex: 1; }
	.introducer > *:first-child { margin-right: 40px; }
	.introducer__title { font-size: 3.5rem; font-weight: 700; padding: 20px 0; }
	.introducer__text { line-height: 1.5; color: #666; }
	.introducer__image { max-height: 650px; max-width: 100%; }
	.introducer__image--small { max-height: 400px; }
	.introducer__applications { display: flex; }
	.introducer__application { margin-right: 10px; }
	.introducer__conditions { margin-top: 30px; color: grey; font-size: 1.2rem; }
	.play { display: flex; align-items: center; font-weight: 700; margin: 40px 0; }
	.play svg { height: 40px; margin-right: 10px; }
	.showcaser-title { font-size: 2.7rem; font-weight: 700; }
	.showcase-text { padding: 10px 0; line-height: 1.5; color: #666; }

	@media (max-width: 768px) {
		.introducer { flex-direction: column; justify-content: center; text-align: center; }
		.introducer > *:first-child { margin-right: 0; }
		.introducer__content { display: flex; flex-direction: column; align-items: center; }
		.play { margin: 20px 0; }
	}
</style>
